// extracted by mini-css-extract-plugin
export var orderDetails = "_un-2";
export var orderImage = "_un-1";
export var orderMeta = "_un-3";
export var orderSummary = "_un-0";
export var rightArrow = "_un-4";